module.exports = require("lodash");


//////////////////
// WEBPACK FOOTER
// external "lodash"
// module id = 1
// module chunks = 0